import { Modal, Popover } from 'antd';
import React from 'react';
import { CustomButton } from '../../../components/utils/Utils';
import style from './orderModal.module.scss';
import moment from 'moment/moment';

const ModalOrderInfo = (props) => {
  const { state, set, dataOrder } = props;
  const { container, table, tableHeader, tableItem, totals } = style;
  //   const totalItems = order.products.reduce((acc, curr) => {
  //     return acc + curr.quantity;
  //   }, 0);
  return (
    <>
      <Modal
        visible={state}
        footer={null}
        onCancel={() => set(!state)}
        width="1200px"
      >
        <div className={container}>
          <div>
            <div>
              <div>
                <h2>
                  Orden n° {dataOrder?.orderNumber} - Fecha{' '}
                  {moment(dataOrder?.createdAt).format('DD/MM/YYYY')} - Generado
                  por{' '}
                  {dataOrder?.isSupplierOrder ? 'Proveedor' : 'Farmacia'}
                </h2>
              </div>
              <div className={style.pharmacyInfo}>
                <div>
                  Farmacia{' '}
                  {dataOrder?.pharmacyUser.pharmacy?.name ||
                    dataOrder?.pharmacyUser.accountNumber}
                </div>
                <div>
                  <div>
                    Telefono:{' '}
                    {dataOrder?.pharmacyUser.pharmacy?.cellPhone || ' - '}
                  </div>
                  <div>
                    Mail: {dataOrder?.pharmacyUser.pharmacy?.email || ' - '}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className={table}>
              <div>
                <div className={tableHeader}>
                  <div>Producto</div>
                  <div>Cantidad</div>
                  <div>Precio farmacia C/IVA</div>
                  <div>Descuento</div>
                  <div>Precio oferta C/IVA</div>
                  <div>Precio total</div>
                </div>
                <div>
                  {dataOrder?.products.map((product) => (
                    <div className={tableItem} key={product.product._id}>
                      <Popover content={product?.product?.description}>
                        <div>{product?.product?.description}</div>
                      </Popover>
                      <div>{product.quantity}</div>
                      <div>
                        $
                        {parseFloat(
                          parseFloat(product.product.pharmacyPrice).toFixed(2),
                        )}
                      </div>
                      <div>
                        {parseFloat(
                          (parseFloat(product.discount) * 100).toFixed(2),
                        )}
                        %
                      </div>
                      <div>
                        $
                        {parseFloat(
                          parseFloat(
                            product.pharmacyUnitPriceWithDiscount,
                          ).toFixed(2),
                        )}
                      </div>
                      <div>
                        $
                        {parseFloat(
                          parseFloat(product.subtotalWithDiscount).toFixed(2),
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className={totals}>
              <div>{/* <h3>Total de articulos: {totalItems}</h3> */}</div>
              <div>
                {/* <h3>Total: ${parseFloat(parseFloat(order.orderTotalWithDiscount).toFixed(2))}</h3> */}
              </div>
            </div>
          </div>
          <div>
            <CustomButton
              onclick={() => set(!state)}
              color="btnOutline"
              size="bg"
              content="CERRAR"
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalOrderInfo;
